import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Requests a temporary download URL for a document. */
export const executeDownload = store.effects.create(
  (feature: Feature) =>
    feature.actions.download.request.observe().pipe(
      rxjs.mergeMap(action =>
        feature.api.createDownloadUrl(action.data.target).pipe(
          rxjs.map(response =>
            feature.actions.download.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.download.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
